import API_MAP from "../../util/API_MAP";
import API_MANAGER from "../../util/API_MANAGER";
import router from "../../router";

const state = {
	isLoading: false,
	language: 'zh', // 语言：zh 中文；en 英文
	currentStep: '', // 当前步骤
	currentUser: {}, // 当前登录用户的信息
	messageConfig: {
		type: 'info',
		message: ''
	},
	alertConfig: {
		type: 'info',
		message: ''
	},
	isProtocolModalShow: false,
	isPasswordValid: true,
	isSecondEnter: false, // 是否第二次进入
	flight_content: '',
	flight_content_en: '',
	hotel_content: '',
	hotel_content_en: '',
	hotel_checkin_date: '',
	hotel_checkout_date: '',
	document_content: '',
	document_content_en: ''
};

const getters = {
	not_finish_information: state => {
		const currentUser = state.currentUser;
		return !currentUser['family_name'] ||
			!currentUser['gender'] ||
			!currentUser['company'] ||
			!currentUser['phone_number'] ||
			!currentUser['first_name'] ||
			!currentUser['location'] ||
			!currentUser['identity_number'] ||
			!currentUser['post'] ||
			!currentUser['birthday'];
	}
};

const actions = {
	// 切换语言
	changeLanguage({commit}, lang) {
		commit('changeLanguage', lang);
	},
	// 获取当前登录用户信息
	getCurrentUser({commit, dispatch}) {
		let api = API_MAP.CURRENT_USER;
		let method = 'get';
		let successCb = (data) => {
			commit('setLoginStatus', true);
			commit('setCurrentUser', data);
			dispatch('getContent');
		};
		let errorCb = () => {};
		// 静默失败，不弹出错误提示
		API_MANAGER({api, method, successCb, errorCb, commit, silentError: true})
	},
	// 登录
	userLogin({commit, state}, payload) {
		let api = API_MAP.USER_LOGIN;
		let method = 'post';
		let successCb = () => {
			window.location.reload();
		};
		let errorCb = (res) => {
			if (res && res.code && (res.code.toString() === '101' || res.code.toString() === '102')) {
				commit('setPasswordValidStatus', false);
			}
		};
		API_MANAGER({api, method, payload, successCb, errorCb, commit})
	},
	// 上传文档
	uploadDocument({commit, state}, {formData, callBack}) {
		let api = API_MAP.DOCUMENT_UPLOAD;
		let method = 'file';
		const payload = formData;
		let successCb = (data) => {
			callBack(data);
		};
		let errorCb = () => {

		};
		API_MANAGER({api, method, payload, successCb, errorCb, commit})
	},
	// 删除文档
	deleteDocument({commit, state}, {id, callBack}) {
		let api = `${API_MAP.DOCUMENT_UPLOAD}/${id}/delete`;
		let method = 'get';
		const payload = { id };
		let successCb = callBack;
		let errorCb = () => {};
		API_MANAGER({api, method, payload, successCb, errorCb, commit})
	},
	// 登出
	logout({commit}) {
		let api = API_MAP.USER_LOGOUT;
		let method = 'get';
		let successCb = () => {
			window.location.reload()
		};
		let errorCb = () => {};
		// 静默失败，不弹出错误提示
		API_MANAGER({api, method, successCb, errorCb, commit, silentError: true})
	},
	// 注册成功
	regSuccess({commit}) {
		let api = API_MAP.REG_SUCCESS;
		let method = 'get';
		let successCb = (data) => {};
		let errorCb = () => {};
		API_MANAGER({api, method, successCb, errorCb, commit})
	},
	// 获取静态文案信息
	getContent({commit}) {
		let api = API_MAP.GET_CONTENT;
		let method = 'get';
		let successCb = (data) => {
			commit('setContent', data);
		};
		let errorCb = () => {};
		// 静默失败，不弹出错误提示
		API_MANAGER({api, method, successCb, errorCb, commit, silentError: true})
	},
	// 查看过与会文件弹窗
	viewDialog({commit}) {
		// 本地状态先改成已读弹窗，不依赖接口返回
		commit('hasViewedDocDialog');
		// 调用状态更新接口
		let api = API_MAP.USER_BASIC_VIEWED_DOC_DIALOG;
		let payload = null;
		let method = 'post';
		let successCb = () => {
			// 默认成功不处理
		};
		let errorCb = () => {
			// 不处理
		};
		API_MANAGER({api, method, payload, successCb, errorCb, commit});
	},
	// 查看过注册成功页
	viewSuccessPage({commit}) {
		// 本地状态先改成已读弹窗，不依赖接口返回
		commit('hasViewedSuccessPage');
		// 调用状态更新接口
		let api = API_MAP.USER_BASIC_VIEWED_SUCCESS_PAGE;
		let payload = null;
		let method = 'post';
		let successCb = () => {
			// 默认成功不处理
		};
		let errorCb = () => {
			// 不处理
		};
		API_MANAGER({api, method, payload, successCb, errorCb, commit});
	}
};

const mutations = {
	// 切换语言
	changeLanguage(state, lang) {
		state.language = lang;
	},
	// 设置登录状态
	setLoginStatus(state, status) {
		state.hasLogin = status;
	},
	// 设置登录用户信息
	setCurrentUser(state, data) {
		if (data.location) {
			data.location = +data.location
		}
		state.currentUser = data;
		const language = state.language;
		// 页面跳转处理
		if(data.is_agree_protocol) {
			state.isSecondEnter = true;
			// 已同意协议，跳转汇总页
			router.push(language === 'zh' ? '/summary' : '/en/summary');
		} else {
			// 未同意协议，跳转协议页
			router.push(language === 'zh' ? '/protocol' : '/en/protocol');
		}
	},
	// 设置全局loading状态
	setLoadingStatus(state, status) {
		state.isLoading = status;
	},
	// 打开对话框
	openAlert(state, params) {
		console.log(params);
		state.alertConfig = {
			type: params.type || 'info',
			message: params.message
		}
	},
	// 打开顶部消息提示
	openMessage(state, params) {
		state.messageConfig = {
			type: params.type || 'info',
			message: params.message
		}
	},
	// 更新登录用户信息
	updateCurrentUser(state, newUser) {
		const currentUser = state.currentUser;
		if (newUser.location) {
			newUser.location = +newUser.location
		}
		state.currentUser = Object.assign({}, currentUser, newUser);
	},
	// 设置协议弹窗展示
	setProtocolModalStatus(state, status) {
		state.isProtocolModalShow = status;
	},
	// 设置密码有效性
	setPasswordValidStatus(state, status) {
		state.isPasswordValid = status;
	},
	// 回到汇总页
	backToSummary(state) {
		if (state.language === 'zh') {
			router.push('/summary');
		} else {
			router.push('/en/summary');
		}
	},
	// 设置文案信息
	setContent(state, data) {
		if(data.flight) {
			state.flight_content = data.flight.zh_content || '';
			state.flight_content_en = data.flight.en_content || '';
		}
		if(data.hotel) {
			state.hotel_content = data.hotel.zh_content || '';
			state.hotel_content_en = data.hotel.en_content || '';
			state.hotel_checkin_date = data.hotel.checkin_date || '';
			state.hotel_checkout_date = data.hotel.checkout_date || '';
		}
		if(data.document) {
			state.document_content = data.document.zh_content || '';
			state.document_content_en = data.document.en_content || '';
		}
	},
	// 与会文档弹窗已读
	hasViewedDocDialog(state) {
		let _currentUser = Object.assign({}, state.currentUser);
		_currentUser.viewed_document_dialog = true;
		state.currentUser = _currentUser;
	},
	// 注册成功已读
	hasViewedSuccessPage(state) {
		let _currentUser = Object.assign({}, state.currentUser);
		_currentUser.viewed_success_page = true;
		state.currentUser = _currentUser;
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
